import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';


const loadingStyle = {
  color: '#777',
};

const LiveStoriesCounter = ({
  loading,
  count,
  onClick,
}) => {
  if (loading) {
    return <Icon name="refresh" loading style={loadingStyle} />;
  }
  if (!loading && count > 0) {
    return (
      <Button
        fluid
        inverted
        color="pink"
        onClick={onClick}
      ><Icon name="circle" size="small" /> { count } live stories</Button>)
    ;
  }
  return null;
};

LiveStoriesCounter.propTypes = {
  loading: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default LiveStoriesCounter;



/** WEBPACK FOOTER **
 ** ./src/components/live-stories-counter/index.js
 **/